var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.submitCompleted
        ? [
            _c("p", { staticClass: "ui-title" }, [_vm._v("Reset password")]),
            _vm._v(" "),
            _c("p", { staticClass: "ui-body" }, [
              _vm._v("Request password reset link by email"),
            ]),
            _vm._v(" "),
            _c(
              "ui-form",
              {
                attrs: {
                  "is-processing": _vm.isProcessing,
                  valid: _vm.formValid,
                },
                on: {
                  "update:valid": function ($event) {
                    _vm.formValid = $event
                  },
                  submit: _vm.forgotPassword,
                },
              },
              [
                _c("ui-input", {
                  attrs: { label: "E-mail", required: "", type: "email" },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ui-layout ui-alignment-center-space-between",
                  },
                  [
                    _c("router-link", { attrs: { to: { name: "Login" } } }, [
                      _vm._v("Back to login"),
                    ]),
                    _vm._v(" "),
                    _c("ui-button", {
                      attrs: {
                        disabled: !_vm.formValid || _vm.isProcessing,
                        primary: "",
                        raised: "",
                        text: "Submit",
                        type: "submit",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _c("p", {
            staticClass: "ui-body",
            domProps: { innerHTML: _vm._s(_vm.forgotSuccessBody) },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }